export let routes = [
  {
    path: '/x3-side-growupRecord',
    name: 'x3-side-growupRecord',
    component: () => import('@x3/js/side/growup-record/growup-record.vue'),
    meta: {
      vx_animate: 'none',
    },
  },
];

export let api = {
  xsGrowupRecord(options) {
    return new Promise((resolve, reject) => {
      app.router.push(
        '/x3-side-growupRecord',
        route => {
          route.meta._resolve = resolve;
          route.meta._reject = reject;
          route.meta.options = options;
        },
        err => {
          console.log(err);
        }
      );
    });
  },
};
